/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventTimestamp
 */
export interface EventTimestamp {
    /**
     * 
     * @type {string}
     * @memberof EventTimestamp
     */
    timestamp?: string;
}

/**
 * Check if a given object implements the EventTimestamp interface.
 */
export function instanceOfEventTimestamp(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventTimestampFromJSON(json: any): EventTimestamp {
    return EventTimestampFromJSONTyped(json, false);
}

export function EventTimestampFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventTimestamp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
    };
}

export function EventTimestampToJSON(value?: EventTimestamp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
    };
}

